import apiClient from "../../../apis/api-client";
import {
  BaseApplicationService,
  SmartApplyApiError,
  reportAsyncError,
} from "@graffer-inc/smart-apply";
import { toast } from "react-toastify";
import { ProcedureEntity } from "../../../domain/procedures/procedure-entity";
import {
  ProcedurePresentation,
  ProcedurePresentationType,
} from "../../../domain/procedures/procedure-presentation-entity";

export type ProcedurePresentationContextProps = {
  procedure?: ProcedureEntity;
  isSubmitting: boolean;
  presentation?: ProcedurePresentation;

  onMountSetting: typeof ProcedurePresentationService.prototype.onMountSetting;
  onPresentationUpdate: typeof ProcedurePresentationService.prototype.onPresentationUpdate;
  onSave: typeof ProcedurePresentationService.prototype.onSave;
};

export class ProcedurePresentationService extends BaseApplicationService<ProcedurePresentationContextProps> {
  state: ProcedurePresentationContextProps = {
    isSubmitting: false,
    procedure: undefined as ProcedureEntity | undefined,
    presentation: undefined,
    onMountSetting: this.onMountSetting.bind(this),
    onPresentationUpdate: this.onPresentationUpdate.bind(this),
    onSave: this.onSave.bind(this),
  };

  constructor(arg: { procedure: ProcedureEntity }) {
    super();
    this.state.procedure = arg.procedure;
  }

  async onMountSetting(procedure: ProcedureEntity) {
    try {
      const { data } = await apiClient.fetchProcedurePresentation(procedure.id);
      const presentation = ProcedurePresentation.fromJSON(data);
      this.setState({
        procedure: procedure,
        presentation: presentation,
      });
    } catch (e) {
      if (SmartApplyApiError.isErrorCode(e, "not_found")) {
        this.setState({
          procedure: procedure,
          presentation: ProcedurePresentation.newFrom(procedure),
        });
        return;
      }
      toast.error("カスタムページ設定の取得に失敗しました。");
      reportAsyncError(e);
    }
  }

  async onPresentationUpdate(update: ProcedurePresentationType) {
    this.setState({
      presentation: ProcedurePresentation.fromJSON(update),
    });
  }

  async onSave() {
    try {
      const { data: saved } = await apiClient.updateProcedurePresentation(
        this.state.procedure!.id,
        this.state.presentation!,
      );
      this.setState({
        presentation: ProcedurePresentation.fromJSON(saved),
      });
      toast.success("カスタムページ設定を更新しました。");
    } catch (e) {
      if (SmartApplyApiError.isRetryable(e)) {
        toast.error(
          "ネットワークエラーなどで更新に失敗しました。再度、保存してください。",
        );
        return;
      }
      reportAsyncError(e);
      toast.error(e);
    }
  }
}
